import {RenderModal} from "../../Functions/RenderModal";

export function SwitchToPartner() {
    const targets = document.querySelectorAll('[data-toggle="partner-checkout-ajax"]');

    // ToDo: Funkt noch nicht einwandfrei
    if (targets.length > 0) {
        targets.forEach((target: HTMLElement) => {
            target.addEventListener('click', (e) => {
                e.preventDefault();
                openModal(target);
            }, {passive: false});
            target.addEventListener('touchend', (e) => {
                e.preventDefault();
                openModal(target);
            }, {passive: false});
        })
    }

    /**
     * open the modal
     *
     * @param element
     */
    const openModal = (element: HTMLElement) => {
        const url = element.dataset.url;
        const additionalData = element.dataset;

        RenderModal.init(
            '',
            '<div class="modal-content-loading"></div>',
            null,
            false,
            null,
            null,
            null,
            (e) => {
                const bootboxBody = e.target.querySelector('.bootbox-body');

                const request = async () => {
                    const response = await fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(additionalData)
                    });

                    return response.text();
                }

                request()
                    .then((html) => {
                        bootboxBody.innerHTML = html;
                    })
                    .then(() => {
                        initPartnerCheckoutModal();
                    });
            }
        );
    }

    /**
     * Init partner checkout modal
     */
    const initPartnerCheckoutModal = () => {
        const goToPartnerBtn: HTMLButtonElement = document.querySelector('.go-to-partner-btn');

        if (goToPartnerBtn) {
            /**
             * Create a request
             *
             * @param uri
             */
            const request = async (uri: string) => {
                const response = await fetch(uri, {
                    headers: {
                        "Content-Type": "application/json",
                    }
                })

                return response.json();
            }

            /**
             * Disable the button and get the items
             * Submits the form
             */
            const eventListener = () => {
                const form = goToPartnerBtn.closest('form');
                const url = form.dataset.getContentsUrl;
                const progressText = goToPartnerBtn.dataset.progressText;

                goToPartnerBtn.disabled = true;
                goToPartnerBtn.textContent = progressText;

                try {
                    request(url)
                        .then((data) => {
                            const item: HTMLInputElement = form.querySelector('input[name="items"]');
                            item.value = JSON.stringify(data);

                            form.submit();
                        });
                } catch (e) {
                    console.error(e);
                }
            }

            goToPartnerBtn.addEventListener('click', eventListener)
            goToPartnerBtn.addEventListener('touchend', eventListener)
        }
    }
}
